module.exports = wp["blob"];